import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import { AuthContext } from "./AuthContext";
import { Web727 } from "web727token";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      console.log("Logging in...");

      const user = await Web727.login(username, password);

      console.log("Login successful:", user);

      login(user);

      navigate("/landing");
    } catch (err) {
      console.error("Login Error:", err);

      console.error("Response:", err.response);
      console.error("Data:", err.response?.data);

      setError(
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.message ||
        "Invalid username or password."
      );
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <h1 className="company-name">My 727 Infotech</h1>
        <div className="underline" />
        <p className="tagline">Your Gateway to Digital Excellence</p>
      </div>

      <div className="login-right">
        <form className="login-form" onSubmit={handleSubmit}>
          <h2>Login</h2>

          {error && <p className="error-message">{error}</p>}

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <button type="submit" className="login-btn">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;